const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://cantabria-backend.onrender.com" // URL del backend en la nube
    : "http://localhost:4000"; // URL del backend local

export default API_URL;